export default __webpack_public_path__ + "static/media/fb.0695f8a6.svg";